import { isCurrentView } from "../../../shared/utils/view-util";
import { initAutocomplete } from "../../../shared/utils/address-autofill-utils";
import { toggleSelectPlaceholderState } from "../../../shared/utils/select-utils";
import { validateStreetAddress } from "../../../shared/utils/street-address-validation-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.business_location")) {
    return;
  }

  const addressContainer = document.getElementById(
    "delivery-address-container",
  );
  const use_business_address_true = document.getElementById(
    "business_location_form_use_business_address_true",
  );
  const use_business_address_false = document.getElementById(
    "business_location_form_use_business_address_false",
  );

  const merchantAddress1Field = document.getElementById("address1");
  const address1Field = document.getElementById("delivery_address1");
  const address2Field = document.getElementById("delivery_address2");
  const postalCodeField = document.getElementById("delivery_postcode");
  const suburbField = document.getElementById("delivery_suburb");
  const cityField = document.getElementById("delivery_city");
  const provinceField = document.getElementById("delivery_province");

  [merchantAddress1Field, address1Field].forEach((field) => {
    if (!field) return;

    ["input", "focusout"].forEach((eventType) => {
      field.addEventListener(eventType, () => validateStreetAddress(field));
    });
  });

  addStoreTypeListener(use_business_address_true);
  addStoreTypeListener(use_business_address_false);
  initAutocomplete(
    address1Field,
    address2Field,
    postalCodeField,
    suburbField,
    cityField,
    provinceField,
  );

  if (use_business_address_false && use_business_address_false.checked) {
    showAddressSection();
  }

  function showAddressSection() {
    if (use_business_address_false.checked === true) {
      addressContainer.classList.remove("tw-hidden");
      addressContainer.classList.add("tw-flex");
      if (!address1Field.value) {
        address1Field.focus();
      }
    } else {
      clearDeliveryAddressFields();
      addressContainer.classList.remove("tw-flex");
      addressContainer.classList.add("tw-hidden");
    }
  }

  function addStoreTypeListener(input) {
    if (input) {
      input.addEventListener("change", () => {
        if (use_business_address_false.checked === true) {
          clearDeliveryAddressFields();
        }
        showAddressSection();
      });
    }
  }

  function clearDeliveryAddressFields() {
    [
      address1Field,
      address2Field,
      postalCodeField,
      suburbField,
      cityField,
      provinceField,
    ].forEach((field) => {
      field.value = "";
      field.setAttribute("value", "");
    });
    toggleSelectPlaceholderState();
  }
});
